import { Message } from 'sw-ui'
import { Toast } from 'vant'
const isPc = !window.navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
)
export default class alterUtils {
  /**
   * 基本信息
   * @param msg
   */
  static alertInfo(msg, showClose, duration) {
    isPc
      ? Message({
          showClose: showClose,
          message: msg,
          duration: typeof duration === 'number' ? duration : 3000,
          type: 'info',
        })
      : Toast(msg)
  }

  /**
   * 成功信息
   * @param msg
   */
  static alertSuccess(msg, showClose) {
    isPc
      ? Message({
          showClose: showClose,
          message: msg,
          type: 'success',
        })
      : Toast.success(msg)
  }

  /**
   * 警告信息
   * @param msg
   */
  static alertWarning(msg, showClose) {
    isPc
      ? Message({
          showClose: showClose,
          message: msg,
          type: 'warning',
        })
      : Toast.fail(msg)
  }

  /**
   * 错误信息
   * @param msg
   */
  static alertError(msg, showClose) {
    isPc
      ? Message({
          showClose: showClose,
          message: msg,
          type: 'error',
        })
      : Toast.fail(msg)
  }
}
